'use strict'

import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import marked from 'marked'
import classnames from 'classnames'

import './FAQAccordions.scss'

class FAQAccordions extends PureComponent {
  constructor () {
    super()
    this.state = {
      activeAccordion: null,
      activeAllAccordion: false
    }
  }

  toggleAccordion = (e, id) => {
    this.setState({
      activeAccordion: id === this.state.activeAccordion ? null : id,
      activeAllAccordion: false
    })
    if (e !== null) e.stopPropagation()
  }

  toggleAllAccordion = (e) => {
    this.setState({
      activeAccordion: null,
      activeAllAccordion: !this.state.activeAllAccordion
    })
    if (e !== null) e.stopPropagation()
  }

  render () {
    const { faqs } = this.props
    const { activeAccordion, activeAllAccordion } = this.state
    const ccn = 'faq-accordions'
    const activeClassName = classnames([ccn], { [ccn + '--active-all']: activeAllAccordion })

    if (!faqs) return null
    return (
      <div className={activeClassName}>
        <div className={ccn + '__header'}>
          <h4 className={ccn + '__title h2'}>FAQs</h4>
          {
            faqs.length >= 2 &&
            <button className={ccn + '__open-all-button'} onClick={(e) => this.toggleAllAccordion(e)} aria-expanded={activeAllAccordion}>
              <span className='sr-only'>Click this button to </span>
              {
                this.state.activeAllAccordion ? 'Collapse all' : 'Expand all'
              }
              <span className='sr-only'> the accordions below.</span>
              <span className={ccn + '__open-all-button__icon'} aria-hidden='true' />
            </button>
          }
        </div>
        {
          this.props.faqs.map((faq, i) => {
            const toggleAccordionClassName = classnames([ccn + '__accordion'], { [ccn + '__accordion--active']: faq.id === activeAccordion })

            return (
              <div className={toggleAccordionClassName} key={i}>
                <button className={ccn + '__button ' + ccn + '__button--' + faq.id} aria-expanded={faq.id === activeAccordion || activeAllAccordion} onClick={(e) => this.toggleAccordion(e, faq.id)}>
                  {faq.question}
                  <span className={ccn + '__icon-question'} aria-hidden='true' />
                  <span className={ccn + '__icon-cheveron'} aria-hidden='true' />
                </button>
                <div className={ccn + '__content'} aria-hidden={faq.id !== activeAccordion && !activeAllAccordion}>
                  <div className='page__content' dangerouslySetInnerHTML={{ __html: marked(faq.answer) }} />
                </div>
              </div>
            )
          })
        }
      </div>
    )
  }
}

FAQAccordions.propTypes = {
  faqs: PropTypes.array
}

export default FAQAccordions
